// extracted by mini-css-extract-plugin
export default {"resetPasswordContainer":"style_resetPasswordContainer__rjaAO","body":"style_body__XFI6p"};